import React, { useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import PackMediaModal from '../Components/PackMediaModal';

const MosaicMediaModal = ({ mediaUrls, totalFeeds, inModal = false, avatarSrc = null }) => {
  const history = useHistory();
  const location = useLocation();

  // Ancho del avatar derivado de la relación de aspecto real de la foto
  // (medida al cargarla), en vez de forzar un cuadrado: así object-cover
  // nunca tiene que recortar nada, porque el contenedor ya tiene la misma
  // proporción que la imagen. Arranca en 1 (cuadrado) hasta que la imagen
  // carga y se conoce la proporción real.
  const [avatarAspectRatio, setAvatarAspectRatio] = useState(1);

  // El visor de fotos se abre empujando una entrada de historial propia,
  // en vez de estado local: así "atrás" (gesto del navegador, botón físico,
  // o el X) solo cierra el visor y no arrastra consigo el modal de perfil
  // que está debajo (que también vive en el historial).
  const mediaUrlsToShow = location.state?.photoViewer || [];
  const showMediaModal = mediaUrlsToShow.length > 0;

  const openMediaViewer = (urls) => {
    history.push({
      pathname: location.pathname,
      search: location.search,
      hash: '#photos',
      state: { ...location.state, photoViewer: urls },
    });
  };

  const closeMediaViewer = () => {
    history.goBack();
  };

  return (
    <>
      <style>{`
        @keyframes neonPulse {
          0%, 100% {
            box-shadow: 0 0 5px rgba(244, 63, 94, 0.5), 0 0 20px rgba(244, 63, 94, 0.7), 0 0 30px rgba(244, 63, 94, 0.8), 0 0 40px rgba(244, 63, 94, 1);
          }
          50% {
            box-shadow: 0 0 2px rgba(244, 63, 94, 0.3), 0 0 10px rgba(244, 63, 94, 0.5), 0 0 15px rgba(244, 63, 94, 0.6), 0 0 20px rgba(244, 63, 94, 0.8);
          }
        }

        .neon-glow {
          animation: neonPulse 1.5s infinite ease-in-out;
          border-color: rgba(244, 63, 94, 1); /* Exact color for rose-500 */
        }
      `}</style>
      <div className={`relative w-full ${inModal ? '' : 'md:-mt-8'}`}>
        {/* Banner con imagen de fondo */}
        <div
          className={`profile-wrapper w-full h-auto pt-4 pb-4 md:pt-0 md:pb-0 md:h-56 bg-none md:bg-cover md:bg-center md:rounded-xl md:border md:shadow-sm md:items-center flex justify-center md:justify-start hover:cursor-pointer`}
          style={{
            backgroundImage: `url(${mediaUrls[1]})`, // Imagen del banner
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '8px',
          }}
          onClick={() => openMediaViewer([mediaUrls[1]])}
        >
          {/* Avatar: alto casi igual al del banner pero con un margen chico
              arriba/abajo (el wrapper ya centra verticalmente con
              md:items-center) para que no quede pegado a los bordes; el
              ancho sale de la proporción real de la foto. Pegado a la
              izquierda del banner, con solo el margen justo para no salirse
              de su esquina redondeada. */}
          <div className="relative h-48 md:h-48 mt-1 md:mt-0 ml-0 md:ml-4" style={{ aspectRatio: avatarAspectRatio }}>
            <div
              className={`w-full h-full overflow-hidden rounded-xl border-4 ${
                totalFeeds > 0 ? 'neon-glow' : 'border-gray-200'
              } shadow-sm hover:cursor-pointer`}
              onClick={(e) => { e.stopPropagation(); openMediaViewer([mediaUrls[0]]); }}
            >
              <img
                src={avatarSrc || mediaUrls[0]}
                alt="Profile"
                className="w-full h-full object-cover"
                onLoad={(e) => {
                  const { naturalWidth, naturalHeight } = e.target;
                  if (naturalWidth && naturalHeight) {
                    setAvatarAspectRatio(naturalWidth / naturalHeight);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {showMediaModal && (
        <PackMediaModal
          show={showMediaModal}
          onClose={closeMediaViewer}
          mediaUrls={mediaUrlsToShow}
        />
      )}
    </>
  );
};

export default MosaicMediaModal;
